/**
 * incomplete, incomplete_expired, trialing, active, past_due, canceled, or unpaid.
 */
import {Price, PriceInterval, Product, ProductMetaData} from '../+prices';
import {CheckHasSubscribed} from '../../+account/account.selectors';
import {TimeStamp} from '../../models/time-stamp.model';
import {Coupon} from '../+invoices';

export enum SubscriptionStatus {
  incomplete = 'incomplete',
  incomplete_expired = 'incomplete_expired',
  trialing = 'trialing',
  active = 'active',
  past_due = 'past_due',
  canceled = 'canceled',
  unpaid = 'unpaid'
}

export interface IsTrialWithDaysRemaining {
  isInTrial: boolean;
  trialDaysRemaining: number;
  hasActiveSubscription: boolean;
}

export interface Trial {
  days: number;
  stripeCoupon: string | null;
  stripeCouponMessage: string | null;
}

export interface StripeCoupon {
  stripeCoupon: string | null;
  stripeCouponMessage: string | null;
}

export interface TrialParams {
  days: number;
  remaining: number;
  hasPromoCode: boolean;
  isInTrial: boolean;
  hasActiveSubscription: boolean;
  hasAccess: boolean;
}

export interface Path {
  segments: string[];
  offset: number;
  len: number;
}

export interface Key {
  path: Path;
}

export interface Options {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export interface Config {
  name: string;
  automaticDataCollectionEnabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Providers {}

export interface Container {
  name: string;
  providers: Providers;
}

export interface App {
  _isDeleted: boolean;
  _options: Options;
  _config: Config;
  _name: string;
  _automaticDataCollectionEnabled: boolean;
  _container: Container;
}

export interface DatabaseId {
  projectId: string;
  database: string;
}

export interface Settings {
  host: string;
  ssl: boolean;
  ignoreUndefinedProperties: boolean;
  cacheSizeBytes: number;
  experimentalForceLongPolling: boolean;
  experimentalAutoDetectLongPolling: boolean;
  useFetchStreams: boolean;
}

export interface Firestore {
  app: App;
  databaseId: DatabaseId;
  settings: Settings;
}

export interface SubscriptionPriceFirestore {
  converter?: any;
  _key: Key;
  type: string;
  firestore: Firestore;
}

export interface Path2 {
  segments: string[];
  offset: number;
  len: number;
}

export interface Key2 {
  path: Path2;
}

export interface Options2 {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export interface Config2 {
  name: string;
  automaticDataCollectionEnabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Providers2 {}

export interface Container2 {
  name: string;
  providers: Providers2;
}

export interface App2 {
  _isDeleted: boolean;
  _options: Options2;
  _config: Config2;
  _name: string;
  _automaticDataCollectionEnabled: boolean;
  _container: Container2;
}

export interface DatabaseId2 {
  projectId: string;
  database: string;
}

export interface Settings2 {
  host: string;
  ssl: boolean;
  ignoreUndefinedProperties: boolean;
  cacheSizeBytes: number;
  experimentalForceLongPolling: boolean;
  experimentalAutoDetectLongPolling: boolean;
  useFetchStreams: boolean;
}

export interface Firestore2 {
  app: App2;
  databaseId: DatabaseId2;
  settings: Settings2;
}

export interface Price2 {
  converter?: any;
  _key: Key2;
  type: string;
  firestore: Firestore2;
}

export interface CurrentPeriodEnd {
  seconds: number;
  nanoseconds: number;
}

export interface Path3 {
  segments: string[];
  offset: number;
  len: number;
}

export interface Key3 {
  path: Path3;
}

export interface Options3 {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export interface Config3 {
  name: string;
  automaticDataCollectionEnabled: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Providers3 {}

export interface Container3 {
  name: string;
  providers: Providers3;
}

export interface App3 {
  _isDeleted: boolean;
  _options: Options3;
  _config: Config3;
  _name: string;
  _automaticDataCollectionEnabled: boolean;
  _container: Container3;
}

export interface DatabaseId3 {
  projectId: string;
  database: string;
}

export interface Settings3 {
  host: string;
  ssl: boolean;
  ignoreUndefinedProperties: boolean;
  cacheSizeBytes: number;
  experimentalForceLongPolling: boolean;
  experimentalAutoDetectLongPolling: boolean;
  useFetchStreams: boolean;
}

export interface Firestore3 {
  app: App3;
  databaseId: DatabaseId3;
  settings: Settings3;
}

export interface SubscriptionProductFirestore {
  converter?: any;
  _key: Key3;
  type: string;
  firestore: Firestore3;
}

export interface CurrentPeriodStart {
  seconds: number;
  nanoseconds: number;
}

export interface Created {
  seconds: number;
  nanoseconds: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Metadata {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Metadata2 {}

export interface Recurring {
  interval_count: number;
  aggregate_usage?: any;
  usage_type: string;
  trial_period_days?: any;
  interval: string;
}

export interface SubscriptionProduct {
  description?: any;
  object: string;
  active: boolean;
  attributes: any[];
  updated: number;
  created: number;
  id: string;
  statement_descriptor?: any;
  name: string;
  livemode: boolean;
  metadata: ProductMetaData;
  type: string;
  tax_code?: any;
  unit_label?: any;
  package_dimensions?: any;
  images: any[];
  shippable?: any;
  url?: any;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Metadata4 {}

export interface SubscriptionPrice {
  lookup_key?: any;
  type: string;
  tiers_mode?: any;
  unit_amount: number;
  recurring: Recurring;
  currency: string;
  active: boolean;
  unit_amount_decimal: string;
  created: number;
  nickname?: any;
  billing_scheme: string;
  object: string;
  livemode: boolean;
  product: SubscriptionProduct;
  transform_quantity?: any;
  metadata: Metadata4;
  id: string;
  tax_behavior: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Metadata5 {}

export interface SubscriptionPlan {
  transform_usage?: any;
  nickname?: any;
  tiers_mode?: any;
  amount_decimal: string;
  trial_period_days?: any;
  billing_scheme: string;
  id: string;
  created: number;
  amount: number;
  interval: PriceInterval;
  currency: string;
  metadata: Metadata5;
  object: string;
  livemode: boolean;
  product: string;
  active: boolean;
  usage_type: string;
  aggregate_usage?: any;
  interval_count: number;
}

export interface SubscriptionItem {
  id: string;
  created: number;
  metadata: Metadata2;
  billing_thresholds?: any;
  price: SubscriptionPrice;
  plan: SubscriptionPlan;
  object: string;
  quantity: number;
  subscription: string;
  tax_rates: any[];
}

export interface SubscriptionProductAndPrice {
  priceEntities: {[priceID: string]: SubscriptionPrice};
  productEntities: {[productID: string]: SubscriptionProduct};
}

/**
 * Used for payment system
 */
export interface ProductWizardStore {
  trialDays: number;

  currentSubscription: Subscription | null;
  currentSubscriptionProduct: SubscriptionItem | null;
  currentSubscriptionStorageProduct: SubscriptionItem | null;
  currentSubscriptionProductPrice: SubscriptionPrice | null;
  currentSubscriptionStoragePrice: SubscriptionPrice | null;

  selectedProduct: Product | null;
  selectedProductPrice: Price | null;

  storageProduct: Product | null;
  baseMonthlyStoragePrice: Price | null;
  baseYearlyStoragePrice: Price | null;
  monthlyStoragePrice: Price | null;
  yearlyStoragePrice: Price | null;

  earlyAdopterAgreementSigned: boolean;

  additionalStoragePerGB: number;
  interval: PriceInterval;
}

/**
 * https://stripe.com/docs/api/subscriptions/object
 */
export interface Subscription {
  price: SubscriptionPriceFirestore;
  cancel_at?: TimeStamp | null;
  prices: Price2[];
  role: string;
  ended_at?: TimeStamp | null;
  cancel_at_period_end: boolean;
  trial_start?: TimeStamp | null;
  current_period_end: CurrentPeriodEnd;
  canceled_at?: TimeStamp | null;
  product: SubscriptionProductFirestore;
  quantity: number;
  current_period_start: CurrentPeriodStart;
  stripeLink: string;
  trial_end?: TimeStamp | null;
  created: Created;
  metadata: Metadata;
  items: SubscriptionItem[];
  status: SubscriptionStatus;
  updatedAtSeconds?: number;
  id: string;
}

export type SubscriptionCancel = Pick<
  Subscription,
  'cancel_at' | 'cancel_at_period_end' | 'canceled_at'
>;

export interface SubscriptionUIItem {
  itemId: string;
  itemPriceProductName: string;
  itemPriceUnit_amount: number;
  itemPriceCurrency: string;
  itemPlanInterval: string;
  itemPriceProductMetadataAccountRole: string;
}

export interface SubscriptionUIdisplay {
  subscription: Subscription;
  subscriptionID: string;
  items: SubscriptionUIItem[];
  hasCoupon: boolean;
  coupon?: Coupon;
}
